import { GetterTree } from 'vuex'
import StoredCardsState from '../types/StoredCardsState'

export const getters: GetterTree<StoredCardsState, any> = {
  getCards: state => state.cards,
  getLocation: state => state.location
}
